import React from "react";
import PropTypes from "prop-types";
import QRCode from "react-qr-code";

import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

function QRCodePanel({ title, value, size, hint, linkUrl, linkText }) {
  return (
    <MKBox mt={4}>
      {title && (
        <MKTypography variant="h6" fontWeight="bold" textAlign="center">
          {title}
        </MKTypography>
      )}

      <MKBox display="flex" justifyContent="center" mt={2}>
        {value ? (
          <QRCode value={value} style={{ width: size, height: size }} />
        ) : (
          <MKTypography variant="caption" color="error">
            未获取到二维码
          </MKTypography>
        )}
      </MKBox>

      {linkUrl && (
        <MKBox textAlign="center" mt={2}>
          <MKTypography
            variant="caption"
            component="a"
            href={linkUrl}
            target="_blank"
            rel="noreferrer"
            display="block"
          >
            {linkText || "打开二维码页面"}
          </MKTypography>
        </MKBox>
      )}

      {hint && (
        <MKTypography variant="caption" color="text" display="block" textAlign="center" mt={1.5}>
          {hint}
        </MKTypography>
      )}
    </MKBox>
  );
}

QRCodePanel.propTypes = {
  title: PropTypes.string,
  value: PropTypes.string,
  size: PropTypes.number,
  hint: PropTypes.string,
  linkUrl: PropTypes.string,
  linkText: PropTypes.string,
};

QRCodePanel.defaultProps = {
  title: "",
  value: "",
  size: 240,
  hint: "",
  linkUrl: "",
  linkText: "",
};

export default QRCodePanel;
